/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CreatePerson,
  GetSimplePersonsParams,
  PersonDto,
  PersonDtoPaginatedData,
  PersonGetPersonDataContactPermissions200One,
  PersonGetPersonDataContactPermissions200Three,
  PersonGetPersonDataContactPermissions200Two,
  PersonGetPersonDataContactPermissionsParams,
  PersonGetPersonListParams,
  PersonGetPersonParams,
  PersonGetPersonTableParams,
  PersonGetPersonsByIdsParams,
  PersonGetPersonsWithSameNameParams,
  PersonGetSearchNameParams,
  PersonGetSimplePersonForContractParams,
  PersonGetSimplePersonParams,
  PersonGetSimplePersonWithUsersParams,
  PersonGetSimplePersonsByIdsParams,
  PersonGetUpdatePersonDetailsDtoParams,
  SimplePerson,
  SimplePersonPagination,
  SimplePersonWithUsers,
  UpdatePersonDetailsDto
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getPersonGetPersonListUrl = (params?: PersonGetPersonListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Person/GetPersonList?${stringifiedParams}` : `/api/Person/GetPersonList`
}

export const personGetPersonList = async (params?: PersonGetPersonListParams, options?: RequestInit): Promise<PersonDtoPaginatedData> => {
  
  return customInstance<PersonDtoPaginatedData>(getPersonGetPersonListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getPersonGetPersonListQueryKey = (params?: PersonGetPersonListParams,) => {
    return [
    `/api/Person/GetPersonList`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getPersonGetPersonListQueryOptions = <TData = Awaited<ReturnType<typeof personGetPersonList>>, TError = ErrorType<unknown>>(params?: PersonGetPersonListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetPersonList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPersonGetPersonListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof personGetPersonList>>> = ({ signal }) => personGetPersonList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof personGetPersonList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PersonGetPersonListQueryResult = NonNullable<Awaited<ReturnType<typeof personGetPersonList>>>
export type PersonGetPersonListQueryError = ErrorType<unknown>


export function usePersonGetPersonList<TData = Awaited<ReturnType<typeof personGetPersonList>>, TError = ErrorType<unknown>>(
 params: undefined |  PersonGetPersonListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetPersonList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof personGetPersonList>>,
          TError,
          Awaited<ReturnType<typeof personGetPersonList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetPersonList<TData = Awaited<ReturnType<typeof personGetPersonList>>, TError = ErrorType<unknown>>(
 params?: PersonGetPersonListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetPersonList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof personGetPersonList>>,
          TError,
          Awaited<ReturnType<typeof personGetPersonList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetPersonList<TData = Awaited<ReturnType<typeof personGetPersonList>>, TError = ErrorType<unknown>>(
 params?: PersonGetPersonListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetPersonList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function usePersonGetPersonList<TData = Awaited<ReturnType<typeof personGetPersonList>>, TError = ErrorType<unknown>>(
 params?: PersonGetPersonListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetPersonList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPersonGetPersonListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPersonGetPersonListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof personGetPersonList>>, TError = ErrorType<unknown>>(params?: PersonGetPersonListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetPersonList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPersonGetPersonListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof personGetPersonList>>> = ({ signal }) => personGetPersonList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetPersonList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PersonGetPersonListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof personGetPersonList>>>
export type PersonGetPersonListSuspenseQueryError = ErrorType<unknown>


export function usePersonGetPersonListSuspense<TData = Awaited<ReturnType<typeof personGetPersonList>>, TError = ErrorType<unknown>>(
 params: undefined |  PersonGetPersonListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetPersonList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetPersonListSuspense<TData = Awaited<ReturnType<typeof personGetPersonList>>, TError = ErrorType<unknown>>(
 params?: PersonGetPersonListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetPersonList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetPersonListSuspense<TData = Awaited<ReturnType<typeof personGetPersonList>>, TError = ErrorType<unknown>>(
 params?: PersonGetPersonListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetPersonList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function usePersonGetPersonListSuspense<TData = Awaited<ReturnType<typeof personGetPersonList>>, TError = ErrorType<unknown>>(
 params?: PersonGetPersonListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetPersonList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPersonGetPersonListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPersonGetSimplePersonWithUsersUrl = (params?: PersonGetSimplePersonWithUsersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Person/GetSimplePersonWithUsers?${stringifiedParams}` : `/api/Person/GetSimplePersonWithUsers`
}

export const personGetSimplePersonWithUsers = async (params?: PersonGetSimplePersonWithUsersParams, options?: RequestInit): Promise<SimplePersonWithUsers> => {
  
  return customInstance<SimplePersonWithUsers>(getPersonGetSimplePersonWithUsersUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getPersonGetSimplePersonWithUsersQueryKey = (params?: PersonGetSimplePersonWithUsersParams,) => {
    return [
    `/api/Person/GetSimplePersonWithUsers`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getPersonGetSimplePersonWithUsersQueryOptions = <TData = Awaited<ReturnType<typeof personGetSimplePersonWithUsers>>, TError = ErrorType<unknown>>(params?: PersonGetSimplePersonWithUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetSimplePersonWithUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPersonGetSimplePersonWithUsersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof personGetSimplePersonWithUsers>>> = ({ signal }) => personGetSimplePersonWithUsers(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof personGetSimplePersonWithUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PersonGetSimplePersonWithUsersQueryResult = NonNullable<Awaited<ReturnType<typeof personGetSimplePersonWithUsers>>>
export type PersonGetSimplePersonWithUsersQueryError = ErrorType<unknown>


export function usePersonGetSimplePersonWithUsers<TData = Awaited<ReturnType<typeof personGetSimplePersonWithUsers>>, TError = ErrorType<unknown>>(
 params: undefined |  PersonGetSimplePersonWithUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetSimplePersonWithUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof personGetSimplePersonWithUsers>>,
          TError,
          Awaited<ReturnType<typeof personGetSimplePersonWithUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetSimplePersonWithUsers<TData = Awaited<ReturnType<typeof personGetSimplePersonWithUsers>>, TError = ErrorType<unknown>>(
 params?: PersonGetSimplePersonWithUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetSimplePersonWithUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof personGetSimplePersonWithUsers>>,
          TError,
          Awaited<ReturnType<typeof personGetSimplePersonWithUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetSimplePersonWithUsers<TData = Awaited<ReturnType<typeof personGetSimplePersonWithUsers>>, TError = ErrorType<unknown>>(
 params?: PersonGetSimplePersonWithUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetSimplePersonWithUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function usePersonGetSimplePersonWithUsers<TData = Awaited<ReturnType<typeof personGetSimplePersonWithUsers>>, TError = ErrorType<unknown>>(
 params?: PersonGetSimplePersonWithUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetSimplePersonWithUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPersonGetSimplePersonWithUsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPersonGetSimplePersonWithUsersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof personGetSimplePersonWithUsers>>, TError = ErrorType<unknown>>(params?: PersonGetSimplePersonWithUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetSimplePersonWithUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPersonGetSimplePersonWithUsersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof personGetSimplePersonWithUsers>>> = ({ signal }) => personGetSimplePersonWithUsers(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetSimplePersonWithUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PersonGetSimplePersonWithUsersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof personGetSimplePersonWithUsers>>>
export type PersonGetSimplePersonWithUsersSuspenseQueryError = ErrorType<unknown>


export function usePersonGetSimplePersonWithUsersSuspense<TData = Awaited<ReturnType<typeof personGetSimplePersonWithUsers>>, TError = ErrorType<unknown>>(
 params: undefined |  PersonGetSimplePersonWithUsersParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetSimplePersonWithUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetSimplePersonWithUsersSuspense<TData = Awaited<ReturnType<typeof personGetSimplePersonWithUsers>>, TError = ErrorType<unknown>>(
 params?: PersonGetSimplePersonWithUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetSimplePersonWithUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetSimplePersonWithUsersSuspense<TData = Awaited<ReturnType<typeof personGetSimplePersonWithUsers>>, TError = ErrorType<unknown>>(
 params?: PersonGetSimplePersonWithUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetSimplePersonWithUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function usePersonGetSimplePersonWithUsersSuspense<TData = Awaited<ReturnType<typeof personGetSimplePersonWithUsers>>, TError = ErrorType<unknown>>(
 params?: PersonGetSimplePersonWithUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetSimplePersonWithUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPersonGetSimplePersonWithUsersSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPersonGetSimplePersonUrl = (params?: PersonGetSimplePersonParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Person/GetSimplePerson?${stringifiedParams}` : `/api/Person/GetSimplePerson`
}

export const personGetSimplePerson = async (params?: PersonGetSimplePersonParams, options?: RequestInit): Promise<SimplePerson> => {
  
  return customInstance<SimplePerson>(getPersonGetSimplePersonUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getPersonGetSimplePersonQueryKey = (params?: PersonGetSimplePersonParams,) => {
    return [
    `/api/Person/GetSimplePerson`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getPersonGetSimplePersonQueryOptions = <TData = Awaited<ReturnType<typeof personGetSimplePerson>>, TError = ErrorType<unknown>>(params?: PersonGetSimplePersonParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetSimplePerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPersonGetSimplePersonQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof personGetSimplePerson>>> = ({ signal }) => personGetSimplePerson(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof personGetSimplePerson>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PersonGetSimplePersonQueryResult = NonNullable<Awaited<ReturnType<typeof personGetSimplePerson>>>
export type PersonGetSimplePersonQueryError = ErrorType<unknown>


export function usePersonGetSimplePerson<TData = Awaited<ReturnType<typeof personGetSimplePerson>>, TError = ErrorType<unknown>>(
 params: undefined |  PersonGetSimplePersonParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetSimplePerson>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof personGetSimplePerson>>,
          TError,
          Awaited<ReturnType<typeof personGetSimplePerson>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetSimplePerson<TData = Awaited<ReturnType<typeof personGetSimplePerson>>, TError = ErrorType<unknown>>(
 params?: PersonGetSimplePersonParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetSimplePerson>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof personGetSimplePerson>>,
          TError,
          Awaited<ReturnType<typeof personGetSimplePerson>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetSimplePerson<TData = Awaited<ReturnType<typeof personGetSimplePerson>>, TError = ErrorType<unknown>>(
 params?: PersonGetSimplePersonParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetSimplePerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function usePersonGetSimplePerson<TData = Awaited<ReturnType<typeof personGetSimplePerson>>, TError = ErrorType<unknown>>(
 params?: PersonGetSimplePersonParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetSimplePerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPersonGetSimplePersonQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPersonGetSimplePersonSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof personGetSimplePerson>>, TError = ErrorType<unknown>>(params?: PersonGetSimplePersonParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetSimplePerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPersonGetSimplePersonQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof personGetSimplePerson>>> = ({ signal }) => personGetSimplePerson(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetSimplePerson>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PersonGetSimplePersonSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof personGetSimplePerson>>>
export type PersonGetSimplePersonSuspenseQueryError = ErrorType<unknown>


export function usePersonGetSimplePersonSuspense<TData = Awaited<ReturnType<typeof personGetSimplePerson>>, TError = ErrorType<unknown>>(
 params: undefined |  PersonGetSimplePersonParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetSimplePerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetSimplePersonSuspense<TData = Awaited<ReturnType<typeof personGetSimplePerson>>, TError = ErrorType<unknown>>(
 params?: PersonGetSimplePersonParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetSimplePerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetSimplePersonSuspense<TData = Awaited<ReturnType<typeof personGetSimplePerson>>, TError = ErrorType<unknown>>(
 params?: PersonGetSimplePersonParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetSimplePerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function usePersonGetSimplePersonSuspense<TData = Awaited<ReturnType<typeof personGetSimplePerson>>, TError = ErrorType<unknown>>(
 params?: PersonGetSimplePersonParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetSimplePerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPersonGetSimplePersonSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPersonGetSimplePersonForContractUrl = (params?: PersonGetSimplePersonForContractParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Person/GetSimplePersonForContract?${stringifiedParams}` : `/api/Person/GetSimplePersonForContract`
}

export const personGetSimplePersonForContract = async (params?: PersonGetSimplePersonForContractParams, options?: RequestInit): Promise<SimplePerson> => {
  
  return customInstance<SimplePerson>(getPersonGetSimplePersonForContractUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getPersonGetSimplePersonForContractQueryKey = (params?: PersonGetSimplePersonForContractParams,) => {
    return [
    `/api/Person/GetSimplePersonForContract`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getPersonGetSimplePersonForContractQueryOptions = <TData = Awaited<ReturnType<typeof personGetSimplePersonForContract>>, TError = ErrorType<unknown>>(params?: PersonGetSimplePersonForContractParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetSimplePersonForContract>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPersonGetSimplePersonForContractQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof personGetSimplePersonForContract>>> = ({ signal }) => personGetSimplePersonForContract(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof personGetSimplePersonForContract>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PersonGetSimplePersonForContractQueryResult = NonNullable<Awaited<ReturnType<typeof personGetSimplePersonForContract>>>
export type PersonGetSimplePersonForContractQueryError = ErrorType<unknown>


export function usePersonGetSimplePersonForContract<TData = Awaited<ReturnType<typeof personGetSimplePersonForContract>>, TError = ErrorType<unknown>>(
 params: undefined |  PersonGetSimplePersonForContractParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetSimplePersonForContract>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof personGetSimplePersonForContract>>,
          TError,
          Awaited<ReturnType<typeof personGetSimplePersonForContract>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetSimplePersonForContract<TData = Awaited<ReturnType<typeof personGetSimplePersonForContract>>, TError = ErrorType<unknown>>(
 params?: PersonGetSimplePersonForContractParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetSimplePersonForContract>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof personGetSimplePersonForContract>>,
          TError,
          Awaited<ReturnType<typeof personGetSimplePersonForContract>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetSimplePersonForContract<TData = Awaited<ReturnType<typeof personGetSimplePersonForContract>>, TError = ErrorType<unknown>>(
 params?: PersonGetSimplePersonForContractParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetSimplePersonForContract>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function usePersonGetSimplePersonForContract<TData = Awaited<ReturnType<typeof personGetSimplePersonForContract>>, TError = ErrorType<unknown>>(
 params?: PersonGetSimplePersonForContractParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetSimplePersonForContract>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPersonGetSimplePersonForContractQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPersonGetSimplePersonForContractSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof personGetSimplePersonForContract>>, TError = ErrorType<unknown>>(params?: PersonGetSimplePersonForContractParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetSimplePersonForContract>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPersonGetSimplePersonForContractQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof personGetSimplePersonForContract>>> = ({ signal }) => personGetSimplePersonForContract(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetSimplePersonForContract>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PersonGetSimplePersonForContractSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof personGetSimplePersonForContract>>>
export type PersonGetSimplePersonForContractSuspenseQueryError = ErrorType<unknown>


export function usePersonGetSimplePersonForContractSuspense<TData = Awaited<ReturnType<typeof personGetSimplePersonForContract>>, TError = ErrorType<unknown>>(
 params: undefined |  PersonGetSimplePersonForContractParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetSimplePersonForContract>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetSimplePersonForContractSuspense<TData = Awaited<ReturnType<typeof personGetSimplePersonForContract>>, TError = ErrorType<unknown>>(
 params?: PersonGetSimplePersonForContractParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetSimplePersonForContract>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetSimplePersonForContractSuspense<TData = Awaited<ReturnType<typeof personGetSimplePersonForContract>>, TError = ErrorType<unknown>>(
 params?: PersonGetSimplePersonForContractParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetSimplePersonForContract>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function usePersonGetSimplePersonForContractSuspense<TData = Awaited<ReturnType<typeof personGetSimplePersonForContract>>, TError = ErrorType<unknown>>(
 params?: PersonGetSimplePersonForContractParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetSimplePersonForContract>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPersonGetSimplePersonForContractSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPersonGetPersonUrl = (params?: PersonGetPersonParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Person/GetPerson?${stringifiedParams}` : `/api/Person/GetPerson`
}

export const personGetPerson = async (params?: PersonGetPersonParams, options?: RequestInit): Promise<PersonDto> => {
  
  return customInstance<PersonDto>(getPersonGetPersonUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getPersonGetPersonQueryKey = (params?: PersonGetPersonParams,) => {
    return [
    `/api/Person/GetPerson`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getPersonGetPersonQueryOptions = <TData = Awaited<ReturnType<typeof personGetPerson>>, TError = ErrorType<unknown>>(params?: PersonGetPersonParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetPerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPersonGetPersonQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof personGetPerson>>> = ({ signal }) => personGetPerson(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof personGetPerson>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PersonGetPersonQueryResult = NonNullable<Awaited<ReturnType<typeof personGetPerson>>>
export type PersonGetPersonQueryError = ErrorType<unknown>


export function usePersonGetPerson<TData = Awaited<ReturnType<typeof personGetPerson>>, TError = ErrorType<unknown>>(
 params: undefined |  PersonGetPersonParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetPerson>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof personGetPerson>>,
          TError,
          Awaited<ReturnType<typeof personGetPerson>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetPerson<TData = Awaited<ReturnType<typeof personGetPerson>>, TError = ErrorType<unknown>>(
 params?: PersonGetPersonParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetPerson>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof personGetPerson>>,
          TError,
          Awaited<ReturnType<typeof personGetPerson>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetPerson<TData = Awaited<ReturnType<typeof personGetPerson>>, TError = ErrorType<unknown>>(
 params?: PersonGetPersonParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetPerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function usePersonGetPerson<TData = Awaited<ReturnType<typeof personGetPerson>>, TError = ErrorType<unknown>>(
 params?: PersonGetPersonParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetPerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPersonGetPersonQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPersonGetPersonSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof personGetPerson>>, TError = ErrorType<unknown>>(params?: PersonGetPersonParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetPerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPersonGetPersonQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof personGetPerson>>> = ({ signal }) => personGetPerson(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetPerson>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PersonGetPersonSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof personGetPerson>>>
export type PersonGetPersonSuspenseQueryError = ErrorType<unknown>


export function usePersonGetPersonSuspense<TData = Awaited<ReturnType<typeof personGetPerson>>, TError = ErrorType<unknown>>(
 params: undefined |  PersonGetPersonParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetPerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetPersonSuspense<TData = Awaited<ReturnType<typeof personGetPerson>>, TError = ErrorType<unknown>>(
 params?: PersonGetPersonParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetPerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetPersonSuspense<TData = Awaited<ReturnType<typeof personGetPerson>>, TError = ErrorType<unknown>>(
 params?: PersonGetPersonParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetPerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function usePersonGetPersonSuspense<TData = Awaited<ReturnType<typeof personGetPerson>>, TError = ErrorType<unknown>>(
 params?: PersonGetPersonParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetPerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPersonGetPersonSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPersonGetPersonsByIdsUrl = (params?: PersonGetPersonsByIdsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["ids"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Person/GetPersonsByIds?${stringifiedParams}` : `/api/Person/GetPersonsByIds`
}

export const personGetPersonsByIds = async (params?: PersonGetPersonsByIdsParams, options?: RequestInit): Promise<PersonDto[]> => {
  
  return customInstance<PersonDto[]>(getPersonGetPersonsByIdsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getPersonGetPersonsByIdsQueryKey = (params?: PersonGetPersonsByIdsParams,) => {
    return [
    `/api/Person/GetPersonsByIds`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getPersonGetPersonsByIdsQueryOptions = <TData = Awaited<ReturnType<typeof personGetPersonsByIds>>, TError = ErrorType<unknown>>(params?: PersonGetPersonsByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetPersonsByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPersonGetPersonsByIdsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof personGetPersonsByIds>>> = ({ signal }) => personGetPersonsByIds(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof personGetPersonsByIds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PersonGetPersonsByIdsQueryResult = NonNullable<Awaited<ReturnType<typeof personGetPersonsByIds>>>
export type PersonGetPersonsByIdsQueryError = ErrorType<unknown>


export function usePersonGetPersonsByIds<TData = Awaited<ReturnType<typeof personGetPersonsByIds>>, TError = ErrorType<unknown>>(
 params: undefined |  PersonGetPersonsByIdsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetPersonsByIds>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof personGetPersonsByIds>>,
          TError,
          Awaited<ReturnType<typeof personGetPersonsByIds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetPersonsByIds<TData = Awaited<ReturnType<typeof personGetPersonsByIds>>, TError = ErrorType<unknown>>(
 params?: PersonGetPersonsByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetPersonsByIds>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof personGetPersonsByIds>>,
          TError,
          Awaited<ReturnType<typeof personGetPersonsByIds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetPersonsByIds<TData = Awaited<ReturnType<typeof personGetPersonsByIds>>, TError = ErrorType<unknown>>(
 params?: PersonGetPersonsByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetPersonsByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function usePersonGetPersonsByIds<TData = Awaited<ReturnType<typeof personGetPersonsByIds>>, TError = ErrorType<unknown>>(
 params?: PersonGetPersonsByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetPersonsByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPersonGetPersonsByIdsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPersonGetPersonsByIdsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof personGetPersonsByIds>>, TError = ErrorType<unknown>>(params?: PersonGetPersonsByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetPersonsByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPersonGetPersonsByIdsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof personGetPersonsByIds>>> = ({ signal }) => personGetPersonsByIds(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetPersonsByIds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PersonGetPersonsByIdsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof personGetPersonsByIds>>>
export type PersonGetPersonsByIdsSuspenseQueryError = ErrorType<unknown>


export function usePersonGetPersonsByIdsSuspense<TData = Awaited<ReturnType<typeof personGetPersonsByIds>>, TError = ErrorType<unknown>>(
 params: undefined |  PersonGetPersonsByIdsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetPersonsByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetPersonsByIdsSuspense<TData = Awaited<ReturnType<typeof personGetPersonsByIds>>, TError = ErrorType<unknown>>(
 params?: PersonGetPersonsByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetPersonsByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetPersonsByIdsSuspense<TData = Awaited<ReturnType<typeof personGetPersonsByIds>>, TError = ErrorType<unknown>>(
 params?: PersonGetPersonsByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetPersonsByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function usePersonGetPersonsByIdsSuspense<TData = Awaited<ReturnType<typeof personGetPersonsByIds>>, TError = ErrorType<unknown>>(
 params?: PersonGetPersonsByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetPersonsByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPersonGetPersonsByIdsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPersonGetSimplePersonsByIdsUrl = (params: PersonGetSimplePersonsByIdsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["ids"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Person/GetSimplePersonsByIds?${stringifiedParams}` : `/api/Person/GetSimplePersonsByIds`
}

export const personGetSimplePersonsByIds = async (params: PersonGetSimplePersonsByIdsParams, options?: RequestInit): Promise<SimplePerson[]> => {
  
  return customInstance<SimplePerson[]>(getPersonGetSimplePersonsByIdsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getPersonGetSimplePersonsByIdsQueryKey = (params?: PersonGetSimplePersonsByIdsParams,) => {
    return [
    `/api/Person/GetSimplePersonsByIds`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getPersonGetSimplePersonsByIdsQueryOptions = <TData = Awaited<ReturnType<typeof personGetSimplePersonsByIds>>, TError = ErrorType<unknown>>(params: PersonGetSimplePersonsByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetSimplePersonsByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPersonGetSimplePersonsByIdsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof personGetSimplePersonsByIds>>> = ({ signal }) => personGetSimplePersonsByIds(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof personGetSimplePersonsByIds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PersonGetSimplePersonsByIdsQueryResult = NonNullable<Awaited<ReturnType<typeof personGetSimplePersonsByIds>>>
export type PersonGetSimplePersonsByIdsQueryError = ErrorType<unknown>


export function usePersonGetSimplePersonsByIds<TData = Awaited<ReturnType<typeof personGetSimplePersonsByIds>>, TError = ErrorType<unknown>>(
 params: PersonGetSimplePersonsByIdsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetSimplePersonsByIds>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof personGetSimplePersonsByIds>>,
          TError,
          Awaited<ReturnType<typeof personGetSimplePersonsByIds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetSimplePersonsByIds<TData = Awaited<ReturnType<typeof personGetSimplePersonsByIds>>, TError = ErrorType<unknown>>(
 params: PersonGetSimplePersonsByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetSimplePersonsByIds>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof personGetSimplePersonsByIds>>,
          TError,
          Awaited<ReturnType<typeof personGetSimplePersonsByIds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetSimplePersonsByIds<TData = Awaited<ReturnType<typeof personGetSimplePersonsByIds>>, TError = ErrorType<unknown>>(
 params: PersonGetSimplePersonsByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetSimplePersonsByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function usePersonGetSimplePersonsByIds<TData = Awaited<ReturnType<typeof personGetSimplePersonsByIds>>, TError = ErrorType<unknown>>(
 params: PersonGetSimplePersonsByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetSimplePersonsByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPersonGetSimplePersonsByIdsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPersonGetSimplePersonsByIdsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof personGetSimplePersonsByIds>>, TError = ErrorType<unknown>>(params: PersonGetSimplePersonsByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetSimplePersonsByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPersonGetSimplePersonsByIdsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof personGetSimplePersonsByIds>>> = ({ signal }) => personGetSimplePersonsByIds(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetSimplePersonsByIds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PersonGetSimplePersonsByIdsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof personGetSimplePersonsByIds>>>
export type PersonGetSimplePersonsByIdsSuspenseQueryError = ErrorType<unknown>


export function usePersonGetSimplePersonsByIdsSuspense<TData = Awaited<ReturnType<typeof personGetSimplePersonsByIds>>, TError = ErrorType<unknown>>(
 params: PersonGetSimplePersonsByIdsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetSimplePersonsByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetSimplePersonsByIdsSuspense<TData = Awaited<ReturnType<typeof personGetSimplePersonsByIds>>, TError = ErrorType<unknown>>(
 params: PersonGetSimplePersonsByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetSimplePersonsByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetSimplePersonsByIdsSuspense<TData = Awaited<ReturnType<typeof personGetSimplePersonsByIds>>, TError = ErrorType<unknown>>(
 params: PersonGetSimplePersonsByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetSimplePersonsByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function usePersonGetSimplePersonsByIdsSuspense<TData = Awaited<ReturnType<typeof personGetSimplePersonsByIds>>, TError = ErrorType<unknown>>(
 params: PersonGetSimplePersonsByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetSimplePersonsByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPersonGetSimplePersonsByIdsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPersonGetPersonTableUrl = (params?: PersonGetPersonTableParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Person/GetPersonTable?${stringifiedParams}` : `/api/Person/GetPersonTable`
}

export const personGetPersonTable = async (params?: PersonGetPersonTableParams, options?: RequestInit): Promise<PersonDtoPaginatedData> => {
  
  return customInstance<PersonDtoPaginatedData>(getPersonGetPersonTableUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getPersonGetPersonTableQueryKey = (params?: PersonGetPersonTableParams,) => {
    return [
    `/api/Person/GetPersonTable`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getPersonGetPersonTableQueryOptions = <TData = Awaited<ReturnType<typeof personGetPersonTable>>, TError = ErrorType<unknown>>(params?: PersonGetPersonTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetPersonTable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPersonGetPersonTableQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof personGetPersonTable>>> = ({ signal }) => personGetPersonTable(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof personGetPersonTable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PersonGetPersonTableQueryResult = NonNullable<Awaited<ReturnType<typeof personGetPersonTable>>>
export type PersonGetPersonTableQueryError = ErrorType<unknown>


export function usePersonGetPersonTable<TData = Awaited<ReturnType<typeof personGetPersonTable>>, TError = ErrorType<unknown>>(
 params: undefined |  PersonGetPersonTableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetPersonTable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof personGetPersonTable>>,
          TError,
          Awaited<ReturnType<typeof personGetPersonTable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetPersonTable<TData = Awaited<ReturnType<typeof personGetPersonTable>>, TError = ErrorType<unknown>>(
 params?: PersonGetPersonTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetPersonTable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof personGetPersonTable>>,
          TError,
          Awaited<ReturnType<typeof personGetPersonTable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetPersonTable<TData = Awaited<ReturnType<typeof personGetPersonTable>>, TError = ErrorType<unknown>>(
 params?: PersonGetPersonTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetPersonTable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function usePersonGetPersonTable<TData = Awaited<ReturnType<typeof personGetPersonTable>>, TError = ErrorType<unknown>>(
 params?: PersonGetPersonTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetPersonTable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPersonGetPersonTableQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPersonGetPersonTableSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof personGetPersonTable>>, TError = ErrorType<unknown>>(params?: PersonGetPersonTableParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetPersonTable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPersonGetPersonTableQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof personGetPersonTable>>> = ({ signal }) => personGetPersonTable(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetPersonTable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PersonGetPersonTableSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof personGetPersonTable>>>
export type PersonGetPersonTableSuspenseQueryError = ErrorType<unknown>


export function usePersonGetPersonTableSuspense<TData = Awaited<ReturnType<typeof personGetPersonTable>>, TError = ErrorType<unknown>>(
 params: undefined |  PersonGetPersonTableParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetPersonTable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetPersonTableSuspense<TData = Awaited<ReturnType<typeof personGetPersonTable>>, TError = ErrorType<unknown>>(
 params?: PersonGetPersonTableParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetPersonTable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetPersonTableSuspense<TData = Awaited<ReturnType<typeof personGetPersonTable>>, TError = ErrorType<unknown>>(
 params?: PersonGetPersonTableParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetPersonTable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function usePersonGetPersonTableSuspense<TData = Awaited<ReturnType<typeof personGetPersonTable>>, TError = ErrorType<unknown>>(
 params?: PersonGetPersonTableParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetPersonTable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPersonGetPersonTableSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetSimplePersonsUrl = (params?: GetSimplePersonsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["workAreaTreeNodes","contractTypeTreeNodes","personCategoryTypes"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Person/GetSimplePersons?${stringifiedParams}` : `/api/Person/GetSimplePersons`
}

export const getSimplePersons = async (params?: GetSimplePersonsParams, options?: RequestInit): Promise<SimplePersonPagination> => {
  
  return customInstance<SimplePersonPagination>(getGetSimplePersonsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetSimplePersonsQueryKey = (params?: GetSimplePersonsParams,) => {
    return [
    `/api/Person/GetSimplePersons`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetSimplePersonsQueryOptions = <TData = Awaited<ReturnType<typeof getSimplePersons>>, TError = ErrorType<unknown>>(params?: GetSimplePersonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimplePersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimplePersonsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimplePersons>>> = ({ signal }) => getSimplePersons(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSimplePersons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSimplePersonsQueryResult = NonNullable<Awaited<ReturnType<typeof getSimplePersons>>>
export type GetSimplePersonsQueryError = ErrorType<unknown>


export function useGetSimplePersons<TData = Awaited<ReturnType<typeof getSimplePersons>>, TError = ErrorType<unknown>>(
 params: undefined |  GetSimplePersonsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimplePersons>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimplePersons>>,
          TError,
          Awaited<ReturnType<typeof getSimplePersons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSimplePersons<TData = Awaited<ReturnType<typeof getSimplePersons>>, TError = ErrorType<unknown>>(
 params?: GetSimplePersonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimplePersons>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimplePersons>>,
          TError,
          Awaited<ReturnType<typeof getSimplePersons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSimplePersons<TData = Awaited<ReturnType<typeof getSimplePersons>>, TError = ErrorType<unknown>>(
 params?: GetSimplePersonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimplePersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetSimplePersons<TData = Awaited<ReturnType<typeof getSimplePersons>>, TError = ErrorType<unknown>>(
 params?: GetSimplePersonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimplePersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSimplePersonsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetSimplePersonsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSimplePersons>>, TError = ErrorType<unknown>>(params?: GetSimplePersonsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimplePersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimplePersonsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimplePersons>>> = ({ signal }) => getSimplePersons(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimplePersons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSimplePersonsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSimplePersons>>>
export type GetSimplePersonsSuspenseQueryError = ErrorType<unknown>


export function useGetSimplePersonsSuspense<TData = Awaited<ReturnType<typeof getSimplePersons>>, TError = ErrorType<unknown>>(
 params: undefined |  GetSimplePersonsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimplePersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSimplePersonsSuspense<TData = Awaited<ReturnType<typeof getSimplePersons>>, TError = ErrorType<unknown>>(
 params?: GetSimplePersonsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimplePersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSimplePersonsSuspense<TData = Awaited<ReturnType<typeof getSimplePersons>>, TError = ErrorType<unknown>>(
 params?: GetSimplePersonsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimplePersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetSimplePersonsSuspense<TData = Awaited<ReturnType<typeof getSimplePersons>>, TError = ErrorType<unknown>>(
 params?: GetSimplePersonsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimplePersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSimplePersonsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPersonGetUpdatePersonDetailsDtoUrl = (params?: PersonGetUpdatePersonDetailsDtoParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Person/GetUpdatePersonDetailsDto?${stringifiedParams}` : `/api/Person/GetUpdatePersonDetailsDto`
}

export const personGetUpdatePersonDetailsDto = async (params?: PersonGetUpdatePersonDetailsDtoParams, options?: RequestInit): Promise<UpdatePersonDetailsDto> => {
  
  return customInstance<UpdatePersonDetailsDto>(getPersonGetUpdatePersonDetailsDtoUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getPersonGetUpdatePersonDetailsDtoQueryKey = (params?: PersonGetUpdatePersonDetailsDtoParams,) => {
    return [
    `/api/Person/GetUpdatePersonDetailsDto`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getPersonGetUpdatePersonDetailsDtoQueryOptions = <TData = Awaited<ReturnType<typeof personGetUpdatePersonDetailsDto>>, TError = ErrorType<unknown>>(params?: PersonGetUpdatePersonDetailsDtoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetUpdatePersonDetailsDto>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPersonGetUpdatePersonDetailsDtoQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof personGetUpdatePersonDetailsDto>>> = ({ signal }) => personGetUpdatePersonDetailsDto(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof personGetUpdatePersonDetailsDto>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PersonGetUpdatePersonDetailsDtoQueryResult = NonNullable<Awaited<ReturnType<typeof personGetUpdatePersonDetailsDto>>>
export type PersonGetUpdatePersonDetailsDtoQueryError = ErrorType<unknown>


export function usePersonGetUpdatePersonDetailsDto<TData = Awaited<ReturnType<typeof personGetUpdatePersonDetailsDto>>, TError = ErrorType<unknown>>(
 params: undefined |  PersonGetUpdatePersonDetailsDtoParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetUpdatePersonDetailsDto>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof personGetUpdatePersonDetailsDto>>,
          TError,
          Awaited<ReturnType<typeof personGetUpdatePersonDetailsDto>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetUpdatePersonDetailsDto<TData = Awaited<ReturnType<typeof personGetUpdatePersonDetailsDto>>, TError = ErrorType<unknown>>(
 params?: PersonGetUpdatePersonDetailsDtoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetUpdatePersonDetailsDto>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof personGetUpdatePersonDetailsDto>>,
          TError,
          Awaited<ReturnType<typeof personGetUpdatePersonDetailsDto>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetUpdatePersonDetailsDto<TData = Awaited<ReturnType<typeof personGetUpdatePersonDetailsDto>>, TError = ErrorType<unknown>>(
 params?: PersonGetUpdatePersonDetailsDtoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetUpdatePersonDetailsDto>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function usePersonGetUpdatePersonDetailsDto<TData = Awaited<ReturnType<typeof personGetUpdatePersonDetailsDto>>, TError = ErrorType<unknown>>(
 params?: PersonGetUpdatePersonDetailsDtoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetUpdatePersonDetailsDto>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPersonGetUpdatePersonDetailsDtoQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPersonGetUpdatePersonDetailsDtoSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof personGetUpdatePersonDetailsDto>>, TError = ErrorType<unknown>>(params?: PersonGetUpdatePersonDetailsDtoParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetUpdatePersonDetailsDto>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPersonGetUpdatePersonDetailsDtoQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof personGetUpdatePersonDetailsDto>>> = ({ signal }) => personGetUpdatePersonDetailsDto(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetUpdatePersonDetailsDto>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PersonGetUpdatePersonDetailsDtoSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof personGetUpdatePersonDetailsDto>>>
export type PersonGetUpdatePersonDetailsDtoSuspenseQueryError = ErrorType<unknown>


export function usePersonGetUpdatePersonDetailsDtoSuspense<TData = Awaited<ReturnType<typeof personGetUpdatePersonDetailsDto>>, TError = ErrorType<unknown>>(
 params: undefined |  PersonGetUpdatePersonDetailsDtoParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetUpdatePersonDetailsDto>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetUpdatePersonDetailsDtoSuspense<TData = Awaited<ReturnType<typeof personGetUpdatePersonDetailsDto>>, TError = ErrorType<unknown>>(
 params?: PersonGetUpdatePersonDetailsDtoParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetUpdatePersonDetailsDto>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetUpdatePersonDetailsDtoSuspense<TData = Awaited<ReturnType<typeof personGetUpdatePersonDetailsDto>>, TError = ErrorType<unknown>>(
 params?: PersonGetUpdatePersonDetailsDtoParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetUpdatePersonDetailsDto>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function usePersonGetUpdatePersonDetailsDtoSuspense<TData = Awaited<ReturnType<typeof personGetUpdatePersonDetailsDto>>, TError = ErrorType<unknown>>(
 params?: PersonGetUpdatePersonDetailsDtoParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetUpdatePersonDetailsDto>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPersonGetUpdatePersonDetailsDtoSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPersonUpdatePersonDetailsUrl = () => {


  

  return `/api/Person/UpdatePersonDetails`
}

export const personUpdatePersonDetails = async (updatePersonDetailsDto: UpdatePersonDetailsDto, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getPersonUpdatePersonDetailsUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updatePersonDetailsDto,)
  }
);}




export const getPersonUpdatePersonDetailsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof personUpdatePersonDetails>>, TError,{data: BodyType<UpdatePersonDetailsDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof personUpdatePersonDetails>>, TError,{data: BodyType<UpdatePersonDetailsDto>}, TContext> => {

const mutationKey = ['personUpdatePersonDetails'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof personUpdatePersonDetails>>, {data: BodyType<UpdatePersonDetailsDto>}> = (props) => {
          const {data} = props ?? {};

          return  personUpdatePersonDetails(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PersonUpdatePersonDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof personUpdatePersonDetails>>>
    export type PersonUpdatePersonDetailsMutationBody = BodyType<UpdatePersonDetailsDto>
    export type PersonUpdatePersonDetailsMutationError = ErrorType<unknown>

    export const usePersonUpdatePersonDetails = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof personUpdatePersonDetails>>, TError,{data: BodyType<UpdatePersonDetailsDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof personUpdatePersonDetails>>,
        TError,
        {data: BodyType<UpdatePersonDetailsDto>},
        TContext
      > => {

      const mutationOptions = getPersonUpdatePersonDetailsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getPersonGetPersonDataContactPermissionsUrl = (params?: PersonGetPersonDataContactPermissionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["personIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Person/GetPersonDataContactPermissions?${stringifiedParams}` : `/api/Person/GetPersonDataContactPermissions`
}

export const personGetPersonDataContactPermissions = async (params?: PersonGetPersonDataContactPermissionsParams, options?: RequestInit): Promise<PersonGetPersonDataContactPermissions200One | PersonGetPersonDataContactPermissions200Two | PersonGetPersonDataContactPermissions200Three> => {
  
  return customInstance<PersonGetPersonDataContactPermissions200One | PersonGetPersonDataContactPermissions200Two | PersonGetPersonDataContactPermissions200Three>(getPersonGetPersonDataContactPermissionsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getPersonGetPersonDataContactPermissionsQueryKey = (params?: PersonGetPersonDataContactPermissionsParams,) => {
    return [
    `/api/Person/GetPersonDataContactPermissions`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getPersonGetPersonDataContactPermissionsQueryOptions = <TData = Awaited<ReturnType<typeof personGetPersonDataContactPermissions>>, TError = ErrorType<unknown>>(params?: PersonGetPersonDataContactPermissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetPersonDataContactPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPersonGetPersonDataContactPermissionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof personGetPersonDataContactPermissions>>> = ({ signal }) => personGetPersonDataContactPermissions(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof personGetPersonDataContactPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PersonGetPersonDataContactPermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof personGetPersonDataContactPermissions>>>
export type PersonGetPersonDataContactPermissionsQueryError = ErrorType<unknown>


export function usePersonGetPersonDataContactPermissions<TData = Awaited<ReturnType<typeof personGetPersonDataContactPermissions>>, TError = ErrorType<unknown>>(
 params: undefined |  PersonGetPersonDataContactPermissionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetPersonDataContactPermissions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof personGetPersonDataContactPermissions>>,
          TError,
          Awaited<ReturnType<typeof personGetPersonDataContactPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetPersonDataContactPermissions<TData = Awaited<ReturnType<typeof personGetPersonDataContactPermissions>>, TError = ErrorType<unknown>>(
 params?: PersonGetPersonDataContactPermissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetPersonDataContactPermissions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof personGetPersonDataContactPermissions>>,
          TError,
          Awaited<ReturnType<typeof personGetPersonDataContactPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetPersonDataContactPermissions<TData = Awaited<ReturnType<typeof personGetPersonDataContactPermissions>>, TError = ErrorType<unknown>>(
 params?: PersonGetPersonDataContactPermissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetPersonDataContactPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function usePersonGetPersonDataContactPermissions<TData = Awaited<ReturnType<typeof personGetPersonDataContactPermissions>>, TError = ErrorType<unknown>>(
 params?: PersonGetPersonDataContactPermissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetPersonDataContactPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPersonGetPersonDataContactPermissionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPersonGetPersonDataContactPermissionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof personGetPersonDataContactPermissions>>, TError = ErrorType<unknown>>(params?: PersonGetPersonDataContactPermissionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetPersonDataContactPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPersonGetPersonDataContactPermissionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof personGetPersonDataContactPermissions>>> = ({ signal }) => personGetPersonDataContactPermissions(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetPersonDataContactPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PersonGetPersonDataContactPermissionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof personGetPersonDataContactPermissions>>>
export type PersonGetPersonDataContactPermissionsSuspenseQueryError = ErrorType<unknown>


export function usePersonGetPersonDataContactPermissionsSuspense<TData = Awaited<ReturnType<typeof personGetPersonDataContactPermissions>>, TError = ErrorType<unknown>>(
 params: undefined |  PersonGetPersonDataContactPermissionsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetPersonDataContactPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetPersonDataContactPermissionsSuspense<TData = Awaited<ReturnType<typeof personGetPersonDataContactPermissions>>, TError = ErrorType<unknown>>(
 params?: PersonGetPersonDataContactPermissionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetPersonDataContactPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetPersonDataContactPermissionsSuspense<TData = Awaited<ReturnType<typeof personGetPersonDataContactPermissions>>, TError = ErrorType<unknown>>(
 params?: PersonGetPersonDataContactPermissionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetPersonDataContactPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function usePersonGetPersonDataContactPermissionsSuspense<TData = Awaited<ReturnType<typeof personGetPersonDataContactPermissions>>, TError = ErrorType<unknown>>(
 params?: PersonGetPersonDataContactPermissionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetPersonDataContactPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPersonGetPersonDataContactPermissionsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPersonCreatePersonUrl = () => {


  

  return `/api/Person/CreatePerson`
}

export const personCreatePerson = async (createPerson: CreatePerson, options?: RequestInit): Promise<number> => {
  
  return customInstance<number>(getPersonCreatePersonUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createPerson,)
  }
);}




export const getPersonCreatePersonMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof personCreatePerson>>, TError,{data: BodyType<CreatePerson>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof personCreatePerson>>, TError,{data: BodyType<CreatePerson>}, TContext> => {

const mutationKey = ['personCreatePerson'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof personCreatePerson>>, {data: BodyType<CreatePerson>}> = (props) => {
          const {data} = props ?? {};

          return  personCreatePerson(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PersonCreatePersonMutationResult = NonNullable<Awaited<ReturnType<typeof personCreatePerson>>>
    export type PersonCreatePersonMutationBody = BodyType<CreatePerson>
    export type PersonCreatePersonMutationError = ErrorType<unknown>

    export const usePersonCreatePerson = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof personCreatePerson>>, TError,{data: BodyType<CreatePerson>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof personCreatePerson>>,
        TError,
        {data: BodyType<CreatePerson>},
        TContext
      > => {

      const mutationOptions = getPersonCreatePersonMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getPersonGetPersonsWithSameNameUrl = (params?: PersonGetPersonsWithSameNameParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Person/GetPersonsWithSameName?${stringifiedParams}` : `/api/Person/GetPersonsWithSameName`
}

export const personGetPersonsWithSameName = async (params?: PersonGetPersonsWithSameNameParams, options?: RequestInit): Promise<PersonDto[]> => {
  
  return customInstance<PersonDto[]>(getPersonGetPersonsWithSameNameUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getPersonGetPersonsWithSameNameQueryKey = (params?: PersonGetPersonsWithSameNameParams,) => {
    return [
    `/api/Person/GetPersonsWithSameName`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getPersonGetPersonsWithSameNameQueryOptions = <TData = Awaited<ReturnType<typeof personGetPersonsWithSameName>>, TError = ErrorType<unknown>>(params?: PersonGetPersonsWithSameNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetPersonsWithSameName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPersonGetPersonsWithSameNameQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof personGetPersonsWithSameName>>> = ({ signal }) => personGetPersonsWithSameName(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof personGetPersonsWithSameName>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PersonGetPersonsWithSameNameQueryResult = NonNullable<Awaited<ReturnType<typeof personGetPersonsWithSameName>>>
export type PersonGetPersonsWithSameNameQueryError = ErrorType<unknown>


export function usePersonGetPersonsWithSameName<TData = Awaited<ReturnType<typeof personGetPersonsWithSameName>>, TError = ErrorType<unknown>>(
 params: undefined |  PersonGetPersonsWithSameNameParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetPersonsWithSameName>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof personGetPersonsWithSameName>>,
          TError,
          Awaited<ReturnType<typeof personGetPersonsWithSameName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetPersonsWithSameName<TData = Awaited<ReturnType<typeof personGetPersonsWithSameName>>, TError = ErrorType<unknown>>(
 params?: PersonGetPersonsWithSameNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetPersonsWithSameName>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof personGetPersonsWithSameName>>,
          TError,
          Awaited<ReturnType<typeof personGetPersonsWithSameName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetPersonsWithSameName<TData = Awaited<ReturnType<typeof personGetPersonsWithSameName>>, TError = ErrorType<unknown>>(
 params?: PersonGetPersonsWithSameNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetPersonsWithSameName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function usePersonGetPersonsWithSameName<TData = Awaited<ReturnType<typeof personGetPersonsWithSameName>>, TError = ErrorType<unknown>>(
 params?: PersonGetPersonsWithSameNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetPersonsWithSameName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPersonGetPersonsWithSameNameQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPersonGetPersonsWithSameNameSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof personGetPersonsWithSameName>>, TError = ErrorType<unknown>>(params?: PersonGetPersonsWithSameNameParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetPersonsWithSameName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPersonGetPersonsWithSameNameQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof personGetPersonsWithSameName>>> = ({ signal }) => personGetPersonsWithSameName(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetPersonsWithSameName>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PersonGetPersonsWithSameNameSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof personGetPersonsWithSameName>>>
export type PersonGetPersonsWithSameNameSuspenseQueryError = ErrorType<unknown>


export function usePersonGetPersonsWithSameNameSuspense<TData = Awaited<ReturnType<typeof personGetPersonsWithSameName>>, TError = ErrorType<unknown>>(
 params: undefined |  PersonGetPersonsWithSameNameParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetPersonsWithSameName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetPersonsWithSameNameSuspense<TData = Awaited<ReturnType<typeof personGetPersonsWithSameName>>, TError = ErrorType<unknown>>(
 params?: PersonGetPersonsWithSameNameParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetPersonsWithSameName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetPersonsWithSameNameSuspense<TData = Awaited<ReturnType<typeof personGetPersonsWithSameName>>, TError = ErrorType<unknown>>(
 params?: PersonGetPersonsWithSameNameParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetPersonsWithSameName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function usePersonGetPersonsWithSameNameSuspense<TData = Awaited<ReturnType<typeof personGetPersonsWithSameName>>, TError = ErrorType<unknown>>(
 params?: PersonGetPersonsWithSameNameParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetPersonsWithSameName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPersonGetPersonsWithSameNameSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPersonGetSearchNameUrl = (params: PersonGetSearchNameParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Person/GetSearchName?${stringifiedParams}` : `/api/Person/GetSearchName`
}

export const personGetSearchName = async (params: PersonGetSearchNameParams, options?: RequestInit): Promise<string> => {
  
  return customInstance<string>(getPersonGetSearchNameUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getPersonGetSearchNameQueryKey = (params?: PersonGetSearchNameParams,) => {
    return [
    `/api/Person/GetSearchName`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getPersonGetSearchNameQueryOptions = <TData = Awaited<ReturnType<typeof personGetSearchName>>, TError = ErrorType<unknown>>(params: PersonGetSearchNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetSearchName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPersonGetSearchNameQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof personGetSearchName>>> = ({ signal }) => personGetSearchName(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof personGetSearchName>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PersonGetSearchNameQueryResult = NonNullable<Awaited<ReturnType<typeof personGetSearchName>>>
export type PersonGetSearchNameQueryError = ErrorType<unknown>


export function usePersonGetSearchName<TData = Awaited<ReturnType<typeof personGetSearchName>>, TError = ErrorType<unknown>>(
 params: PersonGetSearchNameParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetSearchName>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof personGetSearchName>>,
          TError,
          Awaited<ReturnType<typeof personGetSearchName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetSearchName<TData = Awaited<ReturnType<typeof personGetSearchName>>, TError = ErrorType<unknown>>(
 params: PersonGetSearchNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetSearchName>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof personGetSearchName>>,
          TError,
          Awaited<ReturnType<typeof personGetSearchName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetSearchName<TData = Awaited<ReturnType<typeof personGetSearchName>>, TError = ErrorType<unknown>>(
 params: PersonGetSearchNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetSearchName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function usePersonGetSearchName<TData = Awaited<ReturnType<typeof personGetSearchName>>, TError = ErrorType<unknown>>(
 params: PersonGetSearchNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof personGetSearchName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPersonGetSearchNameQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPersonGetSearchNameSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof personGetSearchName>>, TError = ErrorType<unknown>>(params: PersonGetSearchNameParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetSearchName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPersonGetSearchNameQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof personGetSearchName>>> = ({ signal }) => personGetSearchName(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetSearchName>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PersonGetSearchNameSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof personGetSearchName>>>
export type PersonGetSearchNameSuspenseQueryError = ErrorType<unknown>


export function usePersonGetSearchNameSuspense<TData = Awaited<ReturnType<typeof personGetSearchName>>, TError = ErrorType<unknown>>(
 params: PersonGetSearchNameParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetSearchName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetSearchNameSuspense<TData = Awaited<ReturnType<typeof personGetSearchName>>, TError = ErrorType<unknown>>(
 params: PersonGetSearchNameParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetSearchName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePersonGetSearchNameSuspense<TData = Awaited<ReturnType<typeof personGetSearchName>>, TError = ErrorType<unknown>>(
 params: PersonGetSearchNameParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetSearchName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function usePersonGetSearchNameSuspense<TData = Awaited<ReturnType<typeof personGetSearchName>>, TError = ErrorType<unknown>>(
 params: PersonGetSearchNameParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof personGetSearchName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPersonGetSearchNameSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



